import React from "react";
import Grid from "../../partials/content/Grid";
import { Table } from "react-bootstrap";
import { getMaster } from "../../crud/auth.crud";
import EditIcon from '@material-ui/icons/Edit';
 import { Link } from "react-router-dom";
 import { Tooltip } from "@material-ui/core";
 import { IconButton } from '@material-ui/core';
 import Button from '@material-ui/core/Button';

export default class ImplantType extends React.Component {
  state = {
  implants:[]
  }
  componentDidMount()
  {
    
    getMaster('implant').then(response => response.data)
    .then((data) => {
      this.setState({ implants: data })
      //console.log(this.state.users)
     })
  }
  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <Grid beforeCodeTitle="Status" jsCode="true" createPath="/createimplant">
              <div className="kt-section">
               
                <Table striped bordered hover>
                  <thead>
                    <tr>
                     
                      <th>Implant Name</th>
                      <th>Edit</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.implants.map((implant) => (
                    <tr>
                      
                      <td>{implant.implantName} </td>
                      
                      <td>
                          {implant.isEditable &&
                          <Link  to={{pathname:"/editimplant", data: {implant:implant}}}>
                           <Tooltip
                                    title="Edit Implant" 

                                  >
                            <IconButton>
                              <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                            </IconButton>
                            </Tooltip>
                          </Link>
                          }
                      </td>
                    </tr>
                    ))}
                </tbody>
                </Table>
              </div>
            </Grid>
          </div>
         
        </div>

      

       
      </>
    );
  }
}
